var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.treeData)?_c('div',{staticClass:"custom-tree-view"},[_c('CustomTreeItem',{staticClass:"item",attrs:{"item":_vm.treeData},on:{"emitData":function($event){return _vm.$emit('emitData', $event)}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }